import {useDroppable} from '@dnd-kit/core';
import {GridItem} from 'platform/foundation';
import styled from 'styled-components';

import {TestIdProps} from 'shared/web';

import {DashboardGridRect} from '../../types/DashboardGridRect';
import {DashboardTileSize} from '../../types/DashboardTileSize';
import {toDashboardGapSlotId} from '../../utils/toDashboardGapSlotId';
import {toDashboardGridPlacement} from '../../utils/toDashboardGridPlacement';

interface DashboardGapSlotProps extends TestIdProps {
  slot: DashboardGridRect;
  size: DashboardTileSize;
}

// Takes pointer collisions, so it keeps pointer events; it stays below the drop ghosts (z-index 1).
const StyledGapSlot = styled.div`
  height: 100%;
  position: relative;
  z-index: 0;
  border: ${({theme}) => theme.getSize(1)} dashed
    ${({theme}) => theme.colors.palettes.neutral[70][100]};
  border-radius: ${({theme}) => theme.radii.medium};
  background: ${({theme}) => theme.colors.palettes.neutral[70][40]};
`;

export function DashboardGapSlot(props: DashboardGapSlotProps) {
  const {setNodeRef} = useDroppable({id: toDashboardGapSlotId(props.slot)});

  return (
    <GridItem
      {...toDashboardGridPlacement({
        column: props.slot.column,
        row: props.slot.row,
        size: props.size,
      })}
    >
      <StyledGapSlot
        ref={setNodeRef}
        data-column={props.slot.column}
        data-row={props.slot.row}
        data-testid={props['data-testid']}
      />
    </GridItem>
  );
}
